import { render } from "./General_Accept_Dialog.vue?vue&type=template&id=534bffe7&scoped=true&ts=true"
import script from "./General_Accept_Dialog.vue?vue&type=script&lang=ts"
export * from "./General_Accept_Dialog.vue?vue&type=script&lang=ts"

import "./General_Accept_Dialog.vue?vue&type=style&index=0&id=534bffe7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534bffe7"]])

export default __exports__